<a [routerLink]="!disableBtn ? link : undefined" [fragment]="fragment">
  <button
    [type]="typeBtn"
    [class]="'btn ' + classBtn"
    [ngClass]="{ isLoading }"
    [disabled]="disableBtn"
    (click)="clickBtn.emit()">
    @if (!isLoading) {
      <span>{{ name | translate }}</span>
    } @else {
      <div class="loading-container">
        <span class="visibility-hidden">{{ name | translate }}</span>
        @if (isLoading) {
          <app-loader />
        }
      </div>
    }
  </button>
</a>
